module.exports = __webpack_public_path__ + "static/media/caminho-111.3df0fc57.png";